import {
  CREATEPATIENTPRIMARYVITAL,
  GETPATIENTPRIMARYVITAL,
  GETPATIENTPRIMARYVITALBYID,
  UPDATEPATIENTPRIMARYVITAL,
  DELETEPATIENTPRIMARYVITAL,
} from "../actions/types";

const initialState = {};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  switch (action.type) {
    case CREATEPATIENTPRIMARYVITAL:
      return {
        ...state,
        patientPrimaryVitalSaveStatus: action.payload.success,
      };
    case GETPATIENTPRIMARYVITAL:
      return {
        ...state,
        patientPrimaryVitalList: action.payload.data,
      };
    case GETPATIENTPRIMARYVITALBYID:
      return {
        ...state,
        selectedPatientPrimaryVital: action.payload.data,
      };
    case UPDATEPATIENTPRIMARYVITAL:
      return {
        ...state,
        patientPrimaryVitalUpdateStatus: action.payload.success,
      };
    case DELETEPATIENTPRIMARYVITAL:
      return {
        ...state,
        patientPrimaryVitalDeleteStatus: action.payload.success,
      };
    default:
      return state;
  }
}